// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'c08a3cd6-2793-4c15-8c4b-0ce0b74a854c',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: '18ef4af4-c2b6-4467-a6be-470b068fe60c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 438,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '8_Season_Pass_Share_Image',
      parent: 'c08a3cd6-2793-4c15-8c4b-0ce0b74a854c',
      data: {
        DEBUG: true
      }
    },
    {
      id: 'cedb50ba-ba95-47bf-b5fc-dff60375d7f7',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c08a3cd6-2793-4c15-8c4b-0ce0b74a854c'
    },
    {
      id: '66e02a24-7e0a-43aa-8cc2-3e00195ae30b',
      type: 'Container',
      name: 'contentContainer',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 677,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c08a3cd6-2793-4c15-8c4b-0ce0b74a854c',
      data: {
        dynamicValues: {
          y: 'height * 0.528'
        }
      }
    },
    {
      id: 'c8127c90-e958-496a-998b-1bd36767023c',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'cedb50ba-ba95-47bf-b5fc-dff60375d7f7',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height + 50'
        }
      }
    },
    {
      id: '2aa045a9-fb32-4c80-9393-23386976a470',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Image',
      parent: 'cedb50ba-ba95-47bf-b5fc-dff60375d7f7'
    },
    {
      id: 'b37479a3-7615-4964-9544-fb37541c1f9a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 165,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 4.538793,
        y: 1.573276
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16706927,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'cedb50ba-ba95-47bf-b5fc-dff60375d7f7'
    },
    {
      id: '87d5bbbc-f0b8-4be1-99ed-2f644e56ec0c',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 118,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Treasure Pass',
      localize: true,
      maxWidth: 636,
      maxHeight: 149,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x250F48',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '0x250F48',
        dropShadowDistance: 4,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'cedb50ba-ba95-47bf-b5fc-dff60375d7f7'
    },
    {
      id: 'c2e41b61-dc80-4b9d-870d-3ae7f4bde0a3',
      type: 'Container',
      name: 'shareWrapper',
      className: '',
      x: 0,
      y: -169,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '66e02a24-7e0a-43aa-8cc2-3e00195ae30b'
    },
    {
      id: 'faca57c0-fe96-40a9-871a-8646aaa4e30d',
      type: 'Text',
      name: 'descriptionText',
      className: 'colorTags_SPL',
      x: 0,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You reached $Tier @tierNr@$ on the Season Pass!',
      localize: true,
      maxWidth: 575,
      maxHeight: 157,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 570,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '66e02a24-7e0a-43aa-8cc2-3e00195ae30b',
      data: {
        colorTags: {
          $: '#50EEFB'
        }
      }
    },
    {
      id: '610af7ea-1e38-4255-b92e-a24af079e98b',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 384,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '66e02a24-7e0a-43aa-8cc2-3e00195ae30b'
    },
    {
      id: 'dc4ce7f5-067d-430e-9959-3f9b7e74cd51',
      type: 'Container',
      name: 'shareContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c2e41b61-dc80-4b9d-870d-3ae7f4bde0a3'
    },
    {
      id: '01205929-4843-4d87-a636-9340694971f3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Pop_Up',
      parent: 'c2e41b61-dc80-4b9d-870d-3ae7f4bde0a3'
    },
    {
      id: '6933709b-8cdf-4589-ab6d-604e629a3576',
      type: 'Text',
      name: 'closeButton',
      className: '',
      x: 0,
      y: 132,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: -2000,
        width: 2000,
        height: 4000
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '610af7ea-1e38-4255-b92e-a24af079e98b'
    },
    {
      id: 'f8deb3d5-2f64-4805-842d-8e0bc95736d8',
      type: 'Layout',
      name: 'shareButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -8,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '610af7ea-1e38-4255-b92e-a24af079e98b',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '5b1526c2-a9c2-479e-84dc-f47d8b774d4d',
      type: 'Sprite',
      name: '',
      className: 'userAvatar_SPL',
      x: -224,
      y: -21,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3.54,
        y: 3.54
      },
      angle: -13.3,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: 'dc4ce7f5-067d-430e-9959-3f9b7e74cd51'
    },
    {
      id: '75c1ea1a-f870-4f99-81e8-0f03010fc8aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Share_Image',
      parent: 'dc4ce7f5-067d-430e-9959-3f9b7e74cd51'
    },
    {
      id: '245bb506-7b27-4287-948d-150ef60ba16a',
      type: 'Text',
      name: 'rankText',
      className: '',
      x: 104,
      y: -134,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XX',
      localize: false,
      maxWidth: 138,
      maxHeight: 140,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x316E1E',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '0x316E1E',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'dc4ce7f5-067d-430e-9959-3f9b7e74cd51'
    },
    {
      id: 'f450ee97-1c0a-4608-9858-68093aa8405e',
      type: 'Sprite',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Facebook_Icon',
      parent: 'f8deb3d5-2f64-4805-842d-8e0bc95736d8'
    },
    {
      id: '1da8c719-1cb4-4e8d-9ca2-5df4fe049ae2',
      type: 'Text',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 232,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x0047af',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f8deb3d5-2f64-4805-842d-8e0bc95736d8'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  handleResize: false
} as const;

export class SeasonPassSharePopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  header!: Container;
  contentContainer!: Container & { data: typeof raw['list'][3]['data'] };
  shareWrapper!: Container;
  descriptionText!: Text & { data: typeof raw['list'][9]['data'] };
  buttonContainer!: Container;
  shareContainer!: Container;
  closeButton!: Text;
  shareButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][14]['data'] };
  rankText!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Container & { data: typeof raw['list'][3]['data'] } | Sprite & { data: typeof raw['list'][4]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][9]['data'] })[];
  userAvatar_SPL!: (Sprite)[];
  center_SPL!: (Sprite | Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
